import { ReactNode } from "react";
import { useUser } from "../../hooks/use-user";
import NoPermissionRead from "../../ui/components/ui/NoPermission";
import SuperAdminBereich, { SuperAdminAbschnitt } from "./SuperAdminBereich";

/**
 * Jede Seite des Super-Admin-Bereichs (KAN-276, A8).
 *
 * Haelt die Rechtepruefung und den Rahmen an einer Stelle: Jede neue Unterseite erbt beides,
 * statt es zu wiederholen — und eine vergessene Pruefung kann es damit nicht geben. Wer kein
 * Super-Admin ist, sieht nicht einmal, dass es den Bereich gibt.
 */
export const SuperAdminSeite = ({ aktiv, children }: { aktiv: SuperAdminAbschnitt; children: ReactNode }) => {
  const { user } = useUser();

  if (!user) return null;
  if (!user.showSuperadminPanel) return <NoPermissionRead title="Super Admin" />;

  return <SuperAdminBereich aktiv={aktiv}>{children}</SuperAdminBereich>;
};

export default SuperAdminSeite;
